/**
 * Website-scoped JWT support for the webeditor API (websites/auth_scope.py).
 * Override with VITE_WEBSITE_SLUG in .env when needed.
 */

export const WEBSITE_SLUG_HEADER = 'X-Website-Slug';

/** Product slug for Bando Collective (webeditor Website.slug). */
const DEFAULT_WEBSITE_SLUG = 'bandocollective';

export function getWebsiteSlug(): string {
  const raw = (import.meta.env.VITE_WEBSITE_SLUG as string | undefined)?.trim();
  return raw || DEFAULT_WEBSITE_SLUG;
}

export function applyWebsiteScopeHeaders(
  headers: Record<string, string>
): Record<string, string> {
  headers[WEBSITE_SLUG_HEADER] = getWebsiteSlug();
  return headers;
}
